var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7422 17.3825C39.9361 17.3825 40.1301 17.334 40.3482 17.334C43.2816 17.334 45.6573 19.3097 45.6573 21.7522V25.7825C45.6573 28.2067 43.2816 30.2067 40.3482 30.2067C40.1482 30.2067 39.7422 30.1582 39.7422 30.1582",
    stroke: "#084F84",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89697 17.3825C7.70303 17.3825 7.50909 17.334 7.29091 17.334C4.37576 17.334 2 19.3097 2 21.7522V25.7825C2 28.2067 4.37576 30.2067 7.30909 30.2067C7.50909 30.2067 7.70303 30.2067 7.91515 30.1582L8.82424 30.031",
    stroke: "#084F84",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4875 39.049C31.4875 39.8318 31.1765 40.5825 30.623 41.136C30.0695 41.6895 29.3187 42.0005 28.5359 42.0005H20.2814C19.8941 42.0005 19.5106 41.9241 19.1528 41.7757C18.7951 41.6273 18.4701 41.4098 18.1965 41.1356C17.9229 40.8615 17.7061 40.5361 17.5584 40.178C17.4107 39.8199 17.3351 39.4363 17.3359 39.049C17.3359 38.2678 17.6463 37.5186 18.1986 36.9662C18.751 36.4138 19.5002 36.1035 20.2814 36.1035H28.5359C29.3177 36.1035 30.0675 36.4136 30.6208 36.9658C31.1742 37.5181 31.4859 38.2672 31.4875 39.049Z",
    stroke: "#084F84",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0197 37.1515C15.2105 36.749 12.6407 35.3472 10.7817 33.2031C8.92259 31.0591 7.89892 28.3166 7.89844 25.4788V13.7939C7.89844 10.666 9.14101 7.66616 11.3528 5.45437C13.5646 3.24257 16.5644 2 19.6924 2H27.9469C31.0749 2 34.0747 3.24257 36.2865 5.45437C38.4983 7.66616 39.7409 10.666 39.7409 13.7939V30.2061",
    stroke: "#084F84",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsIcon);
export default __webpack_public_path__ + "static/media/csIcon.ecc0d7b7d54cb8e1803a5c64bd09c1f2.svg";
export { ForwardRef as ReactComponent };